import { useEffect, useState } from "react";

/**
 * Returns the current time in milliseconds, updated on an interval while `active`.
 * Use to show live elapsed duration for in-progress ingest runs.
 */
export function useNowTick(active: boolean, intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!active) return;
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [active, intervalMs]);
  return now;
}
